export const REMINDER_TYPES = {
  ONE_TIME: 'ONE_TIME',
  REPEATING: 'REPEATING'
};

export const REMINDER_TYPES_LABELS = {
  [REMINDER_TYPES.ONE_TIME]: 'One-time',
  [REMINDER_TYPES.REPEATING]: 'Repeating'
};

export const REMINDER_TYPES_OPTIONS = [
  { value: REMINDER_TYPES.ONE_TIME, label: REMINDER_TYPES_LABELS[REMINDER_TYPES.ONE_TIME] },
  { value: REMINDER_TYPES.REPEATING, label: REMINDER_TYPES_LABELS[REMINDER_TYPES.REPEATING] },
];

export const REMINDER_STATUSES = {
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  COMPLETED: 'COMPLETED',
  DELETED: 'DELETED',
  FAILED: 'FAILED',
};

export const REMINDER_STATUSES_LABELS = {
  [REMINDER_STATUSES.ACTIVE]: 'Active',
  [REMINDER_STATUSES.PAUSED]: 'Paused',
  [REMINDER_STATUSES.COMPLETED]: 'Completed',
  [REMINDER_STATUSES.DELETED]: 'Deleted',
  [REMINDER_STATUSES.FAILED]: 'Failed',
};

// Combined filter that matches reminders the user is currently managing
// (anything not yet completed, deleted or failed). Used as the default view
// so toggling a reminder between ACTIVE and PAUSED never hides it.
export const REMINDER_STATUS_FILTER_ACTIVE_OR_PAUSED = 'ACTIVE_OR_PAUSED';

export const REMINDER_STATUSES_FILTER_OPTIONS = [
  { value: REMINDER_STATUS_FILTER_ACTIVE_OR_PAUSED, label: 'Active & Paused' },
  { value: 'ALL', label: 'All' },
  { value: REMINDER_STATUSES.ACTIVE, label: REMINDER_STATUSES_LABELS[REMINDER_STATUSES.ACTIVE] },
  { value: REMINDER_STATUSES.PAUSED, label: REMINDER_STATUSES_LABELS[REMINDER_STATUSES.PAUSED] },
  { value: REMINDER_STATUSES.COMPLETED, label: REMINDER_STATUSES_LABELS[REMINDER_STATUSES.COMPLETED] },
  { value: REMINDER_STATUSES.DELETED, label: REMINDER_STATUSES_LABELS[REMINDER_STATUSES.DELETED] },
  { value: REMINDER_STATUSES.FAILED, label: REMINDER_STATUSES_LABELS[REMINDER_STATUSES.FAILED] },
];

export const REMINDERS_PAGE_SIZE = 10;

export const REMINDER_FREQUENCIES = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  ANNUAL: 'ANNUAL',
};

export const REMINDER_FREQUENCIES_LABELS = {
  [REMINDER_FREQUENCIES.DAILY]: 'Daily',
  [REMINDER_FREQUENCIES.WEEKLY]: 'Weekly',
  [REMINDER_FREQUENCIES.MONTHLY]: 'Monthly',
  [REMINDER_FREQUENCIES.ANNUAL]: 'Annual',
};

export const REMINDER_FREQUENCIES_OPTIONS = [
  { value: REMINDER_FREQUENCIES.DAILY, label: REMINDER_FREQUENCIES_LABELS[REMINDER_FREQUENCIES.DAILY] },
  { value: REMINDER_FREQUENCIES.WEEKLY, label: REMINDER_FREQUENCIES_LABELS[REMINDER_FREQUENCIES.WEEKLY] },
  { value: REMINDER_FREQUENCIES.MONTHLY, label: REMINDER_FREQUENCIES_LABELS[REMINDER_FREQUENCIES.MONTHLY] },
  { value: REMINDER_FREQUENCIES.ANNUAL, label: REMINDER_FREQUENCIES_LABELS[REMINDER_FREQUENCIES.ANNUAL] },
];

export const REMINDER_RANGE_SUPPORTED_FREQUENCIES = [
  REMINDER_FREQUENCIES.DAILY,
  REMINDER_FREQUENCIES.WEEKLY,
  REMINDER_FREQUENCIES.MONTHLY,
];

export const EMPTY_REMINDER_RANGE = {
  rangeStartMonth: null,
  rangeStartDay: null,
  rangeEndMonth: null,
  rangeEndDay: null,
};

export const REMINDER_RANGE_FIELD_KEYS = Object.keys(EMPTY_REMINDER_RANGE);
